import React from 'react';

interface ICheckboxProps {
    label: String | (() => JSX.Element),
    checked?: boolean,
    onChange?: React.ChangeEventHandler<HTMLInputElement>
}

export const Checkbox: React.FC<ICheckboxProps> = ({ label, checked=false, onChange = () => {'mp'} }) => {
    let LabelPrint: String | JSX.Element;
    switch (typeof label) {
        case 'function':
            LabelPrint = label()
            break;
        default:
            LabelPrint = label
            break;
    }
    return (
        <label className="checkbox">
            <input type="checkbox" checked={checked} onChange={onChange}/>
            <span className="checkbox__icon"></span> 
            <span>{LabelPrint}</span>
        </label>
    )
};

